angular.module('app').config(prepaymentReportsRouting);

function prepaymentReportsRouting($routeProvider) {
  $routeProvider.when('/prepayment_report', {
    pageTitle: 'PREPAYMENTS_REPORT',
    template: '<prepayment-report-list></prepayment-report-list>',
    menu: 'reports',
    accessPermission: 'index_booking_accountadmin',
    authReq: true,
  });
}

prepaymentReportsRouting.$inject = ['$routeProvider'];
